import { CommonService } from "../../../../../services/CommonService";
import MaritalStatus from "../../components/MaritalStauts";
import { order } from "../SmartSearchParammeter";

export default async function MaritalStatusSearchConfig(key) {
  let maritalStatus = await CommonService.getAllMaritalStatus();
  return {
    description: "Marital Status",
    id: "maritalStatusId",
    initial: [],
    type: order.second,
    handleValues: (searchObject) => {
      return;
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <MaritalStatus searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact"],
    list: maritalStatus.map((m) => m.description.replace(/,/g, "#")),

    handler: function (searchObj, value) {
      searchObj["maritalStatusId"] = maritalStatus
        .filter((m) => value[0] == m.description.replace(/#/g, ",").trim())
        .map((m) => m.id)
        .shift();
    }
  };
}
